export default class StylistApiRequestsPaths {
  static readonly GET_SEARCHES_GENERAL_PERFORMANCE_PER_DAY = 'search/v3/stylist/reports/generalPerformance'
}
